module.exports = __webpack_public_path__ + "img/5.41acab0f.png";